import React from 'react';
import CountUp from 'react-countup';
import VisibilitySensor from "react-visibility-sensor";
 
class FunFact extends React.Component {
    state = {
        didViewCountUp: false
    };

    onVisibilityChange = isVisible => {
        if (isVisible) {
            this.setState({ didViewCountUp: true });
        }
    };

    render(){
        return (
            <section id="stats" className="funfacts-area ptb-120 " style={{marginTop: "10px"}}>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-3 col-6 col-sm-6">
                            <div className="single-funfact">
                                <div className="icon">
                                    {/* <i className="icofont-focus"></i> */}
                                    <img src='/assets/images/events.svg'  height={70} />
                                </div>
                                <h3 className="odometer">
                                    <VisibilitySensor
                                        onChange={this.onVisibilityChange}
                                        offset={{
                                            top: 10
                                        }}
                                        delayedCall
                                    >
                                        <CountUp
                                            start={0}
                                            end={
                                                this.state.didViewCountUp
                                                    ? 500
                                                    : 0
                                            }
                                            duration={3}
                                            suffix='+'
                                        />
                                    </VisibilitySensor>
                                </h3>
                                <p>Events Organised</p>
                            </div>
                        </div>
                        
                        <div className="col-lg-3 col-6 col-sm-6">
                            <div className="single-funfact">
                                <div className="icon">
                                    {/* <i className="icofont-airplane-alt"></i> */}
                                    <img src='/assets/images/travel.svg'  height={70} />
                                </div>
                                <h3 className="odometer">
                                    <VisibilitySensor
                                        onChange={this.onVisibilityChange}
                                        offset={{
                                            top: 10
                                        }}
                                        delayedCall
                                    >
                                        <CountUp
                                            start={0}
                                            end={
                                                this.state.didViewCountUp
                                                    ? 1500
                                                    : 0
                                            }
                                            duration={3}
                                            suffix='+'
                                        />
                                    </VisibilitySensor>
                                </h3>
                                <p>Travel Packages Sold</p>
                            </div>
                        </div>

                        <div className="col-lg-3 col-6 col-sm-6">
                            <div className="single-funfact">
                                <div className="icon">
                                    {/* <i className="icofont-user"></i> */}
                                    <img src='/assets/images/customer.svg'  height={70} />
                                </div>
                                <h3 className="odometer">
                                    <VisibilitySensor
                                        onChange={this.onVisibilityChange}
                                        offset={{
                                            top: 10
                                        }}
                                        delayedCall
                                    >
                                        <CountUp
                                            start={0}
                                            end={
                                                this.state.didViewCountUp
                                                    ? 100
                                                    : 0
                                            }
                                            duration={3}
                                            suffix='%'
                                        />
                                    </VisibilitySensor>
                                </h3>
                                <p> Customer Satisfaction Rate
                                </p>
                            </div>
                        </div>

                        <div className="col-lg-3 col-6 col-sm-6">
                            <div className="single-funfact">
                                <div className="icon">
                                    {/* <i className="icofont-users-social"></i> */}
                                    <img src='/assets/images/experience.svg'  height={70} fill="white" />
                                    {/* <svg height="100" src="/assets/images/experience.svg" fill="white" /> */}
                                
                                </div>
                                <h3 className="odometer">
                                    <VisibilitySensor
                                        onChange={this.onVisibilityChange}
                                        offset={{
                                            top: 10
                                        }}
                                        delayedCall
                                    >
                                        <CountUp
                                            start={0}
                                            end={
                                                this.state.didViewCountUp
                                                    ? 10
                                                    : 0
                                            }
                                            duration={3}
                                            suffix='+'
                                        />
                                    </VisibilitySensor>
                                </h3>
                                <p> Years Of Expertise</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}
 
export default FunFact;